import type { Query } from '@tanstack/react-query'

import { type Address, isAddress, isAddressEqual } from 'viem'

export const isUserQuery =
  (userAddress: Address) =>
  (query: Query): boolean => {
    const keyInput = query.queryKey[1]
    if (typeof keyInput !== 'object' || keyInput === null || !('input' in keyInput)) return false

    const input = keyInput.input
    if (typeof input !== 'object' || input === null || !('userAddress' in input)) return false

    const queryUserAddress = input.userAddress
    if (typeof queryUserAddress !== 'string' || !isAddress(queryUserAddress)) return false
    return isAddressEqual(queryUserAddress, userAddress)
  }
